export const FundingTypes = {
	DOTATION: "z dotacji",
	OWN_FINANCIAL_CONTRIBUTION: "środki finansowe własne",
	OWN_HUMAN_CONTRIBUTION: "wkład osobowy",
	OWN_CONTRIBUTION_IN_KIND: "wkład rzeczowy",
	MONEY_FROM_RECIPIENTS: "świadczenie pieniężne od odbiorców",
	OTHER: "pozostałe",
	OTHER_PUBLIC_SOURCE: "środki finansowe z innych źródeł publicznych",
	INCOME: "przychody",
	INTEREST: "odsetki",
	ALL: "some unused string",
};
